$(document).ready(function () {

    $(document).on('click', '.dropbtn', function () {
        $(".dropdown-content").removeClass("show");
        $(this).next(".dropdown-content").addClass("show");
    });

    $(document).on('click', function (event) {
        // Check if the clicked target is outside of the dropdown
        if (!$(event.target).closest('.dropdown-content, .dropbtn').length) {
            $(".dropdown-content").removeClass("show");
        }
    });

    $(document).on('click', '.dropdown-item', function () {
        var selectedBtnVal = $(this).attr("data-value");
        var selectedBtnDes = $(this).attr("data-des");
        var index = $(this).index(); // Get the index of the clicked item
        var warrantyItemProdId = $(this).attr("data-mainprodid");
        var warrantyItemPrice = parseFloat($(this).attr("data-price"));
        var warrantyItemVariantId = $(this).attr("data-variant");
        var warrantyItemMultiplier = parseInt($(this).attr("data-multiplier")) || 1;

        if (selectedBtnVal !== "Standard 90-Day Warranty") {
            $(this).siblings(".dropdown-item").removeClass("activeWarranty");
            $(this).addClass("activeWarranty");
            $(this).parent(".dropdown-content").prev(".dropbtn").children("svg").hide();
            $(this).parent(".dropdown-content").prev(".dropbtn").children("span")
                .addClass("selected-style")
                .html(`<b id="warranty-${index}">${selectedBtnVal}</b> - <span class="pra_side">${selectedBtnDes}</span> - <span class="after_slide"> $${warrantyItemPrice} </span>`);
        } else {
            $(this).siblings(".dropdown-item").removeClass("activeWarranty");
            $(this).removeClass("activeWarranty");
            $(this).parent(".dropdown-content").prev(".dropbtn").children("svg").show();
            $(this).parent(".dropdown-content").prev(".dropbtn").children("span")
                .addClass("selected-style")
                .html(`<b id="warranty-${index}">${selectedBtnVal}</b><span class="pra_side"></span> - <span class="after_slide"> $${warrantyItemPrice}`);
        }

        $(".dropdown-content").removeClass("show");

        updateWarrantyInLocalStorage(warrantyItemProdId, warrantyItemPrice, warrantyItemVariantId);
        var currentSubTotalText = $(".miniCartSubTotal").attr("data-subTotal");
        var finalTotal = $(".finalTotal").attr("data-finalTotal");
        $(".originalSubTotal span.money").text(`$${currentSubTotalText}`);
        $(".finalTotalMoney span.money").text(`$${finalTotal}`);
        var allWarrantyItemPrice = getAllWarrantyItemPrice();
        if (allWarrantyItemPrice > 0) {
            updateCartTotalWithWarrantyPrice(allWarrantyItemPrice, warrantyItemMultiplier);
        }

    });


    function getAllWarrantyItemPrice() {
        var warrantyData = JSON.parse(localStorage.getItem('warranty')) || [];
        var totalWarrantyPrice = 0;
    
        // Sum up the prices of all warranty items where price is not null or 0
        warrantyData.forEach(function(item) {
            if (item.price && item.price > 0) {
                totalWarrantyPrice += parseFloat(item.price);
            }
        });
    
        return totalWarrantyPrice;
    }

    // Function to update warranty data in local storage
    function updateWarrantyInLocalStorage(prodId, price, variantId) {
        var warrantyData = JSON.parse(localStorage.getItem('warranty')) || [];
    
        // Remove any existing item with the same prodId
        warrantyData = warrantyData.filter(function(item) {
            return item.prodId !== prodId;
        });
    
        // Add the new warranty item
        warrantyData.push({
            prodId: prodId,
            price: price,
            variantId: variantId
        });
    
        // Save the updated warranty data back to local storage
        localStorage.setItem('warranty', JSON.stringify(warrantyData));
    }

    

    // Function to update the total price in the cart
    function updateCartTotalWithWarrantyPrice(warrantyItemPrice, warrantyItemMultiplier) {
        var updatedWarrantyItemPrice = warrantyItemPrice * warrantyItemMultiplier
        var currentSubTotalText = $(".miniCartSubTotal").attr("data-subTotal");
        var finalTotal = $(".finalTotal").attr("data-finalTotal");
        var currentSubTotal = parseFloat(currentSubTotalText.replace(/[$,]/g, '')); // Remove $ sign and commas
        var finalTotalValue = parseFloat(finalTotal.replace(/[$,]/g, '')); // Remove $ sign and commas

        var newSubTotal = currentSubTotal + updatedWarrantyItemPrice;
        var newFinalTotal = finalTotalValue + updatedWarrantyItemPrice;
        newSubTotal = newSubTotal.toFixed(2);
        newFinalTotal = newFinalTotal.toFixed(2);

        // Format the new total with commas and two decimal places
        var formattedTotal = newSubTotal.toLocaleString("en-US", {
            style: "currency",
            currency: "USD"
        });

        var formattedFinalTotal = newFinalTotal.toLocaleString("en-US", {
            style: "currency",
            currency: "USD"
        });


        // Update the cart total display with the new total price
        $(".originalSubTotal span.money").text(`$${formattedTotal}`);
        $(".finalTotalMoney span.money").text(`$${formattedFinalTotal}`);
    }


    $(document).on('click', 'button.customFreeProdAddBtn', function () {
        var $this = $(this);
        var imgUrl = $(this).attr('data-img');
        var prodName = $(this).attr('data-prodname');
        var variantId = $(this).attr('data-variant');
        var variantQty = 1;
        var variantTitle = "";

        if ($(".freedProdOptions").length > 0) {
            variantId = $(".freedProdOptions").val();
            variantTitle = $(".freedProdOptions").find("option:selected").attr("title");
        }
        var cartItemHtml = $(".appendCartSampleHtml").html();
        var $cartItemHtml = $(cartItemHtml);
        cartItemHtml = cartItemHtml.replace('%freeProdImg%', imgUrl);
        cartItemHtml = cartItemHtml.replace('%freeProdTitle%', prodName);
        cartItemHtml = cartItemHtml.replace('%variantId%', variantId);
        cartItemHtml = cartItemHtml.replace('%prodPrice%', 'Free');
        cartItemHtml = cartItemHtml.replace('%variantTitle%', variantTitle);

        if ($(".free_gift_container").length > 0) {
            if ($(".freeProdAddedContainer").length > 0) {
                $(".freeProdAddedContainer").empty().html(cartItemHtml);
                $(".free_gift_container").hide();
            }
            localStorage.removeItem('freeProditem');
            var localStorageContent = $('.freeProdAddedContainer').html();
            localStorage.setItem('freeProditem', localStorageContent);
        }

    });

    $(document).on('click', 'button.freeProdRemoveBtn', function () {
        if ($(".free_gift_container").length == 0) {
            $(".freeProdAddedContainer").empty();
            localStorage.removeItem('freeProditem');
        }
        $(".freeProdAddedContainer").empty();
        localStorage.removeItem('freeProditem');
        $(".free_gift_container").show();
    });

    $(document).on('click', 'button.checkoutFinalBtn', function () {
        $(this).addClass("disabledBtn");
        if ($(".needToRemoveItems").length > 0) {

            var lineItemsToRemove = {};

            $(".needToRemoveItems").each(function () {
                var lineItem = parseInt($(this).attr("data-variant-id"));
                lineItemsToRemove[lineItem] = 0; // Set the quantity to 0 to remove the item
            });

            // Construct the object of line item updates
            var updates = { updates: lineItemsToRemove };
            // Make the AJAX request to update the cart
            jQuery.post(window.Shopify.routes.root + 'cart/update.js', updates)
                .then(response => {
                    console.log('All items removed from cart:', response);
                    addFreeProduct($(this));

                })
                .fail((xhr, status, error) => {
                    console.error('Error removing items from cart:', error);
                    addFreeProduct($(this));
                });

        } else {
            addFreeProduct($(this));
        }
    });


    function addFreeProduct(clickBtn) {
        var finalProdForCart = [];

        if (localStorage.getItem('freeProditem') !== null) {
            if ($(".freeProdAddedContainer .external_content").length > 0) {
                var freeProdVariantId = $(".freeProdAddedContainer .external_content").attr("data-variant");
                finalProdForCart.push({
                    id: freeProdVariantId,
                    quantity: 1,
                    properties: {
                        "Free Product": "true"
                    }
                });
            }
        }

        if ($(".warranty_products .activeWarranty").length > 0) {
            $(".warranty_products .activeWarranty").each(function () {
                var warantProdVariantId = $(this).attr("data-variant");
                var warantMainProdTitle = $(this).attr("data-mainProd");
                var warrantySku = $(this).attr("data-sku");
                var warrantyItqmQty = parseInt($(this).attr("data-multiplier")) || 1;
                finalProdForCart.push({
                    id: warantProdVariantId,
                    quantity: warrantyItqmQty,
                    properties: {
                        "Ext. Warranty For": warrantySku
                    }
                });

            });
        }

        if (finalProdForCart.length > 0) {
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: { items: finalProdForCart },
                dataType: "json",
                success: function () {
                   localStorage.removeItem("recommendedDynamicItemHtml");
                    $(".thirdRecommendedProdOriginal").show();
                    $(".thirdRecommendedProdDummy").empty();
                    localStorage.removeItem('freeProditem');
                    window.location.href = "/checkout";
                    $(clickBtn).removeClass("disabledBtn");
                },
                error: function () {
                    console.log("ERROR");
                    window.location.href = "/checkout";
                    $(clickBtn).removeClass("disabledBtn");
                }
            });
        }
        else {
            window.location.href = "/checkout";
            $(clickBtn).removeClass("disabledBtn");
        }
    }

    $(document).on('click', '.button-add-to-cart', function () {
        var intervalId = setInterval(function () {
            if ($('body').hasClass('header-mini-cart-open')) {
                clearInterval(intervalId);
                if (localStorage.getItem('freeProditem') !== null) {
                    if ($(".freeProdAddedContainer").length > 0) {
                        var addedFreeProdHtml = localStorage.getItem('freeProditem');
                        $(".freeProdAddedContainer").empty().html(addedFreeProdHtml);
                        $(".free_gift_container").hide();
                    }
                }
                if ($(".free_gift_container").length < 1) {
                    $(".freeProdAddedContainer").empty();
                    localStorage.removeItem('freeProditem');
                    $(".free_gift_container").show();
                }
            }
        }, 1000);
    });

    if ($(".needToRemoveItems").length > 0) {

        var lineItemsToRemove = {};

        $(".needToRemoveItems").each(function () {
            var lineItem = parseInt($(this).attr("data-variant-id"));
            lineItemsToRemove[lineItem] = 0; // Set the quantity to 0 to remove the item
        });

        // Construct the object of line item updates
        var updates = { updates: lineItemsToRemove };
        // Make the AJAX request to update the cart
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', updates)
            .then(response => {
                console.log('All items removed from cart:', response);
                updateCartView();

            })
            .fail((xhr, status, error) => {
                console.error('Error removing items from cart:', error);
            });

    }

    function checkFreeItemAlreadyAddedOrNot() {
        if (localStorage.getItem('freeProditem') !== null) {
            if ($(".freeProdAddedContainer").length > 0) {
                var addedFreeProdHtml = localStorage.getItem('freeProditem');
                $(".freeProdAddedContainer").empty().html(addedFreeProdHtml);
                $(".free_gift_container").hide();
            }
        }
        if ($(".free_gift_container").length < 1) {
            $(".freeProdAddedContainer").empty();
            localStorage.removeItem('freeProditem');
            $(".free_gift_container").show();
        }
    }

    checkFreeItemAlreadyAddedOrNot();


    function  checkWarrantyProductsAddedOrNot(){
        function updateCartTotalWithWarrantyPrice(warrantyItemPrice) {
            var currentSubTotalText = $(".miniCartSubTotal").attr("data-subTotal");
            var finalTotal = $(".finalTotal").attr("data-finalTotal");
            var currentSubTotal = parseFloat(currentSubTotalText.replace(/[$,]/g, '')); // Remove $ sign and commas
            var finalTotalValue = parseFloat(finalTotal.replace(/[$,]/g, '')); // Remove $ sign and commas

            var newSubTotal = currentSubTotal + warrantyItemPrice;
            var newFinalTotal = finalTotalValue + warrantyItemPrice;
            newSubTotal = newSubTotal.toFixed(2);
            newFinalTotal = newFinalTotal.toFixed(2);

            // Format the new total with commas and two decimal places
            var formattedTotal = newSubTotal.toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
            });

            var formattedFinalTotal = newFinalTotal.toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
            });


            // Update the cart total display with the new total price
            $(".originalSubTotal span.money").text(`$${formattedTotal}`);
            $(".finalTotalMoney span.money").text(`$${formattedFinalTotal}`);
        }

        function activateWarrantyItemsOnLoad() {
            // Retrieve warranty data from local storage
            var warrantyData = JSON.parse(localStorage.getItem('warranty')) || [];

            // Iterate over each warranty item in local storage
            warrantyData.forEach(function (item) {
                var prodId = item.prodId;
                var variantId = item.variantId

                // Check if an element with the matching data-variant exists in the DOM
                var $warrantyElement = $(`[data-selectingId="${prodId}-${variantId}"]`);
                

                if ($warrantyElement.length > 0) {
                    var $slectedWarrant = $warrantyElement;
                    var selectedBtnVal = $slectedWarrant.attr("data-value");
                    var selectedBtnDes = $slectedWarrant.attr("data-des");
                    var warrantyItemPrice = parseFloat($slectedWarrant.attr("data-price"));
                    var index = $slectedWarrant.index(); // Get the index of the clicked item
                    $slectedWarrant.siblings(".activeWarranty").removeClass("activeWarranty");
                    $slectedWarrant.addClass("activeWarranty");
                    $slectedWarrant.parent(".dropdown-content").prev(".dropbtn").children("svg").hide();
                    $slectedWarrant.parent(".dropdown-content").prev(".dropbtn").children("span").addClass("selected-style").html(`<b id="warranty-${index}">${selectedBtnVal}</b> - <span class="pra_side">${selectedBtnDes}</span> - <span class="after_slide">$${warrantyItemPrice}</span>`);

                } else {
                    // Remove the warranty item from local storage if the element does not exist
                    warrantyData = warrantyData.filter(function (warrantyItem) {
                        return warrantyItem.prodId !== prodId;
                    });
                }
            });

            localStorage.setItem('warranty', JSON.stringify(warrantyData));

            var currentSubTotalText = $(".miniCartSubTotal").attr("data-subTotal");
            var finalTotal = $(".finalTotal").attr("data-finalTotal");
            $(".originalSubTotal span.money").text(`$${currentSubTotalText}`);
            $(".finalTotalMoney span.money").text(`$${finalTotal}`);
            var allWarrantyItemPrice = getAllWarrantyItemPrice();
            if (allWarrantyItemPrice > 0) {
                updateCartTotalWithWarrantyPrice(allWarrantyItemPrice);
            }

            function getAllWarrantyItemPrice() {
                var warrantyData = JSON.parse(localStorage.getItem('warranty')) || [];
                var totalWarrantyPrice = 0;
            
                // Sum up the prices of all warranty items where price is not null or 0
                warrantyData.forEach(function(item) {
                    if (item.price && item.price > 0) {
                        var warrantyElem = $(`[data-selectingId="${item.prodId}-${item.variantId}"]`);
                        var warrantyItemMultiplier = parseInt(warrantyElem.attr("data-multiplier")) || 1;
                        var itemPrice = item.price * warrantyItemMultiplier;
                        totalWarrantyPrice += parseFloat(itemPrice);
                    }
                });
            
                return totalWarrantyPrice;
            }

        }
        
        activateWarrantyItemsOnLoad();
    }

    checkWarrantyProductsAddedOrNot();
    
    const originalFetch = window.fetch;
    window.fetch = async function () {
        const response = await originalFetch.apply(this, arguments);
    
        if (arguments[0].includes('/cart/add')) {
            if (response.ok) {
                console.log('cart/add API hit with successful response');
                setTimeout(function () {
                    checkWarrantyProductsAddedOrNot();
                }, 1200);
    
            } else {
                console.log('cart/add API hit, but response was not successful:', response.status);
            }
        }
    
        return response;
    };
    

    // discount code applying code start 

    $(document).on('click', '#apply-discount', function (event) {
        event.preventDefault(); // Prevent any default action
        var discountCode = $('#discount-code').val();
        $(".discount-error").hide();
        checkDiscountCodeValidation(discountCode);
    });

    function checkDiscountCodeValidation(discountCode) {
        if (!discountCode) {
            $('.discount-error').text('Please enter a discount code.').show();
            return;
        }

        $.ajax({
            url: 'https://gorecon-discount-validator-app-v1.vercel.app/discount/validate',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ discountCode: discountCode }),
            success: function (data) {
                if (data.valid) {
                    console.log("DATA IS VALID");
                    $(".discount-error").hide();
                    applyDiscountCode(discountCode);
                } else {
                    $('.discount-error').text(data.error).show();
                }
            },
            error: function () {
                $('.discount-error').text('Invalid Discount Code').show();
            }
        });
    }


    function applyDiscountCode(discountCode) {
        fetch('/discount/' + discountCode, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                // Check if the response is not ok (e.g., 4xx or 5xx status codes)
                if (!response.ok) {
                    updateCartView();
                    return response.text().then(text => { throw new Error(text); });
                }
                updateCartView();
                return response.json();
            })
            .then(data => {
                // Check if the discount was successfully applied
                if (data && data.status === 'success') {
                    updateCartView();
                } else {
                    updateCartView();
                    throw new Error(data.message || 'Invalid discount code.');
                }
            })
            .catch(error => {
            });
    }

   
    function updateCartView() {
        $.ajax({
            url: '/search',
            method: 'GET',
            success: function (response) {
                // Create a temporary div to hold the response HTML
                var tempDiv = $('<div>').html(response);

                // Extract the content for the two specific parts
                var miniCartContent = tempDiv.find('#HeaderMiniCart #header-mini-cart-content').html();
                var miniCartFooter = tempDiv.find('#HeaderMiniCart #header-mini-cart-footer').html();

                // Update only the specific parts if they exist in the DOM
                if ($("#HeaderMiniCart #header-mini-cart-content").length > 0) {
                    $('#HeaderMiniCart #header-mini-cart-content').html(miniCartContent);
                }
                if ($("#HeaderMiniCart #header-mini-cart-footer").length > 0) {
                    $('#HeaderMiniCart #header-mini-cart-footer').html(miniCartFooter);
                }
                checkWarrantyProductsAddedOrNot();
                setTimeout(function () {
                    loadDynamicRecommendedProd();
                }, 900);
            },
            error: function (xhr, status, error) {
                console.error('Error fetching the HTML:', error);
            }
        });
    }

    // discount code applying code end 

    const closeIcon = $('#close_icon');
    const buttonDrawerHeaderDismiss = $('.button-drawer-header-dismiss');
    closeIcon.on('click', function () {
        if (buttonDrawerHeaderDismiss.length) {
            buttonDrawerHeaderDismiss.click();
        } else {
            console.error('Element with class .button-drawer-header-dismiss not found');
        }
    });



    function initializeCustomDropdown() {
        const $originalSelect = $('.free_gift_area #variant-select');
        const $customDropdown = $('.free_gift_area .custom-warranty-dropdown');
        const $selectedOption = $customDropdown.find('.selected-option');
        const $dropdownOptions = $customDropdown.find('.dropdown-options');
        const $dropdownOptionElements = $customDropdown.find('.dropdown-option');

        // Automatically select the first option on page load
        if ($dropdownOptionElements.length > 0) {
            const $firstOption = $dropdownOptionElements.first();
            const value = $firstOption.data('value');
            const text = $firstOption.text();

            // Update the original select element
            $originalSelect.val(value).trigger('change');

            // Update the selected option text
            $selectedOption.contents().filter(function () {
                return this.nodeType === 3;
            }).first().replaceWith(text + ' ');
        }

        // Toggle the display of the dropdown options and the arrow icon direction
        $(document).on('click', '.custom-warranty-dropdown', function (e) {
            $(this).toggleClass("open");
            $(this).children(".dropdown-options").toggle();
        });

        // Update the original select and the selected option text when a custom option is clicked
        $(document).on('click', '.dropdown-option', function (e) {
            e.stopPropagation(); // Prevent event from bubbling up to document
            const $this = $(this);
            const value = $(this).data('value');
            const text = $(this).text();

            // Update the original select element
            $('.free_gift_area #variant-select').val(value).trigger('change');

            // Update the selected option text
            $(this).parent(".dropdown-options").prev(".selected-option").text(text);

            // Hide the dropdown options
            $(".custom-warranty-dropdown").removeClass("open");
            $(".custom-warranty-dropdown").children(".dropdown-options").hide();
            console.log('Option selected:', text);
        });

        // Hide the dropdown options when clicking outside
        $(document).on('click', function (event) {
            if (!$customDropdown.is(event.target) && $customDropdown.has(event.target).length === 0) {
                $dropdownOptions.css('display', 'none');
                $customDropdown.removeClass('open');
                console.log('Clicked outside, dropdown closed');
            }
        });
    }

    // Check if the dropdown is already present
    if ($('.custom-warranty-dropdown').length > 0) {
        initializeCustomDropdown();
    } else {
        // Use a MutationObserver to initialize when the dropdown is added to the DOM
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if ($(mutation.addedNodes).find('.custom-warranty-dropdown').length > 0) {
                    initializeCustomDropdown();
                    observer.disconnect(); // Stop observing once initialized
                }
            });
        });

        // Start observing the document for added nodes
        observer.observe(document.body, { childList: true, subtree: true });
    }

       
   setTimeout(function() { 
       
    $(document).on('click', '.ga-product_addtocart', function () {
     setTimeout(function() { 
     console.log("updated");
      updateCartView();
      $('body').addClass("header-mini-cart-open drawer-open");
  }, 2000);  
    });
 }, 2000);

  $(document).on("click", ".addUpsellBtn", function () {
        const $addToCartButton = $(this);
        const productId = $addToCartButton.data('product-id');
        const variantSelector = $(this).parent(".product-actions-add-to-cart").prev(".product-actions-select-variant").children(".variant-select");

        const selectedVariantId = $(variantSelector).val();
        const $message = $addToCartButton.siblings('.add-to-cart-message');

        if (selectedVariantId) {
            // AJAX request to add the selected variant to the cart
            $.ajax({
                url: '/cart/add.js',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                data: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
                dataType: 'json',
                success: function (data) {
                    // Show success message
                    $message.show();
                    setTimeout(() => { $message.hide(); }, 2000);

                    // Call updateCartView function to update the cart UI
                    updateCartView();

                    console.log('Added to cart:', data);
                },
                error: function (error) {
                    console.error('Error adding to cart:', error);
                }
            });
        } else {
            alert('Please select an option before adding to cart.');
        }
    });


  // ==== DYNAMIC RECOMMENDED PROD IN CART DRAWER CODE START ====

function renderDynamicUpsells() {
    let storedData = JSON.parse(localStorage.getItem("cartUpsellDataObj")) || {};
    
    let meta1List = [];
    let meta2List = [];
    
    Object.values(storedData).forEach(item => {
        if (item.meta1) meta1List.push(item.meta1);
        if (item.meta2) meta2List.push(item.meta2);
    });
    
    let combinedUpsells = [];
    
    meta1List.forEach(html => {
        if (combinedUpsells.length < 4 && !combinedUpsells.includes(html)) {
            combinedUpsells.push(html);
        }
    });
    
    meta2List.forEach(html => {
        if (combinedUpsells.length < 4 && !combinedUpsells.includes(html)) {
            combinedUpsells.push(html);
        }
    });
    
    for (let i = 1; i <= 4; i++) {
        let dynamicHtml = combinedUpsells[i - 1]; 
        let $dynamicSlot = $(`.dynamic-slot-${i}`);
        let $originalSlot = $(`.original-slot-${i}`);
        
        if (dynamicHtml) {
            $dynamicSlot.html(dynamicHtml).show();
            $originalSlot.hide();
        } else {
            $dynamicSlot.empty().hide();
            $originalSlot.show();
        }
    }
}

function syncUpsellsWithCart() {
    $.getJSON('/cart.js', function(cart) {
        let activeProductIds = cart.items.map(item => item.product_id.toString());
        let storedData = JSON.parse(localStorage.getItem("cartUpsellDataObj")) || {};
        let dataChanged = false;
        let currentTime = Date.now();

        // Using productId as key allows for consistent sync
        Object.keys(storedData).forEach(productId => {
            if (!activeProductIds.includes(productId)) {
                let itemTimestamp = storedData[productId].timestamp || 0;
                if ((currentTime - itemTimestamp) > 5000) {
                    delete storedData[productId];
                    dataChanged = true;
                }
            }
        });

        if (dataChanged) {
            localStorage.setItem("cartUpsellDataObj", JSON.stringify(storedData));
        }
        
        renderDynamicUpsells();
    });
}

$(document).on("click", ".product-info-wrap-content .readyForAddingBtn", function () {
    const template1 = $($(this).attr("data-prodContainer"));
    const template2 = $($(this).attr("data-prodcontainer2"));

    const meta1Html = template1.length ? template1.html() : null;
    const meta2Html = template2.length ? template2.html() : null;
    
    const parentRefClass = template1.length ? template1.attr("data-prodCheckId") : "fallback";
    // Extract the numeric ID to use as the unique key
    const productId = parentRefClass.match(/\d+/) ? parentRefClass.match(/\d+/)[0] : parentRefClass;

    let storedData = JSON.parse(localStorage.getItem("cartUpsellDataObj")) || {};
    
    // Storing by productId ensures that adding the same item again refreshes/overwrites the data
    if (meta1Html || meta2Html) {
        storedData[productId] = {
            refClass: parentRefClass, 
            meta1: meta1Html,
            meta2: meta2Html,
            timestamp: Date.now() 
        };
        localStorage.setItem("cartUpsellDataObj", JSON.stringify(storedData));
        
        renderDynamicUpsells();
        syncUpsellsWithCart();
    }
});


// Run smart sync on load
syncUpsellsWithCart();

// Shopify AJAX Failsafe
$(document).ajaxComplete(function(event, xhr, settings) {
    if (settings.url.includes('/cart')) {
        setTimeout(syncUpsellsWithCart, 200);
    }
});
// ==== DYNAMIC RECOMMENDED PROD IN CART DRAWER CODE END ====

});
